// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"424":"ed4aa3c5","592":"bf6ca574","744":"5e81a1a4"}[chunkId] + ".chunk.js";
};